const config = {
    SHOW_SCROLL_TO_TOP: true,
    ...window.config,
}
export default config
